import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function TikTokIcon(props) {
  return (
    <SvgIcon {...props} htmlColor="black" viewBox="0 0 24 24">
      <path d="M12.75 2h2.5a5.75 5.75 0 0 0 5.75 5.75v2.5a8.25 8.25 0 0 1-6.25-3.05v7.05a6.75 6.75 0 1 1-6.75-6.75 6.8 6.8 0 0 1 1.25.11v2.53a4.25 4.25 0 1 0 3 4.05V2z" />
    </SvgIcon>
  );
}
